import MuiErrorMessage from './mui-error-message-view'
export default MuiErrorMessage
